module.exports = "/images/latamcargopb.png?6e4f30febaa6697ce89d4bbb65d4af35";